import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import cn from 'classnames';
import * as companyResource from 'resources/company/hooks';
import * as userResource from 'resources/user/hooks';
import getSideBarTabs from 'pages/_app/PageConfig/MainLayout/helpers/sideBarTabs';
import AiTaskReady from './AiTaskReady';
import TabItem from './TabItem';
import AccountMenu from './AccountMenu';
import styles from './styles.module.scss';

const DesktopSideBar = ({ disabled, isTopBannerVisible }) => {
  const { data: user } = userResource.useCurrentUser();
  const { data: company } = companyResource.useCompany(user?.company_id);

  const sideButtonTabs = useMemo(() => getSideBarTabs(user, company), [user, company]);

  const upperTabs = sideButtonTabs.filter((tab) => !tab?.isOnBottom);
  const bottomTabs = sideButtonTabs.filter((tab) => tab?.isOnBottom);
  return (
    <nav className={cn(styles.wrapper, { [styles.withTopBanner]: isTopBannerVisible })}>
      <p className={styles.menu}>MENU</p>

      <div className={styles.tabContainer}>

        <div>
          {upperTabs.map((tab) => (
            <TabItem key={tab.label} tab={tab} disabled={disabled} user={user} company={company} />
          ))}
        </div>

        <div>
          <AiTaskReady />
          <AccountMenu tabs={bottomTabs} disabled={disabled} user={user} company={company} />
        </div>

      </div>
    </nav>
  );
};

DesktopSideBar.propTypes = {
  disabled: PropTypes.bool,
  isTopBannerVisible: PropTypes.bool,
};

DesktopSideBar.defaultProps = {
  disabled: false,
  isTopBannerVisible: false,
};

export default React.memo(DesktopSideBar);
